import initAboutSeries from './init-about-series';
import initCast from './init-cast';
import initInfoGraphic from './init-info-graphic';
import initRelatedResources from './init-related-resources';
import initYouTubeChannels from './init-youtube-channels';
function init() {
    //console.log("[LazyLoadModules] init");
    initAboutSeries();
    initCast();
    initInfoGraphic();
    initRelatedResources();
    initYouTubeChannels();
}
const LazyLoadModules = {
    init

}
export default LazyLoadModules;